export const COMMON_MAX_REPORT_COMMITMENT_TIME_MINUTES = 6; // If learn mode is open for 6 minutes (0.1 of 1 hour), record the study time
